export const reviewTemplateKeys = {
  prefix: 'reviewTemplates',
  list: (workspaceId: number) => [reviewTemplateKeys.prefix, workspaceId, 'list'],
}
